import {
  AIActivator,
  getTranslatedText,
  withErrorBoundary
} from '@nile/components';
import React from 'react';
import { useIntl } from 'react-intl';

const AIOptions = (props) => {
  const { options } = props;
  const intl = useIntl();

  return (
    <div className="flex g10 wrap">
      {options.map((option) => {
        const disabledTooltip = option?.disabledTooltip
          ? getTranslatedText(intl, option?.disabledTooltip)
          : null;
        const progressTooltip = option?.progressTooltip
          ? getTranslatedText(intl, option?.progressTooltip)
          : null;
        return (
          <AIActivator
            uiType="Option"
            label={option?.label}
            featureName={option?.featureName}
            icon={option?.icon}
            roleToCheck={option?.roleToCheck}
            roleCheckType={option?.roleCheckType}
            disabledTooltip={disabledTooltip}
            productToCheck={option?.productToCheck}
            progressTooltip={progressTooltip}
            flagToCheck={option?.flagToCheck}
            overrideIcon={false}
          />
        );
      })}
    </div>
  );
};

export default withErrorBoundary(AIOptions);
